// FearGreedWidget/FearGreedFetcher.js
// Singleton — does exactly 1 thing: raw I/O via CmcService. No mapping, no business logic.
import cmcService from '../../../services/CmcService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'FearGreedFetcher';

class FearGreedFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the raw fear & greed history (last 31 days) from CmcService.
     * @returns {Promise<{rk:string,value:number,class:string,ems:number}[]>}
     */
    fetch = async () => {
        try {
            const response = await cmcService.getFearIndices();
            return response?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const fearGreedFetcher = new FearGreedFetcher();
export default fearGreedFetcher;
